import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import AdminLogin from './views/Admin-Login';
import Navbars from './common/Navbar';
import CustomerDetails from './views/Customer-Details';
import Page404 from './views/Page-404';
import CustomerDetailsList from './views/Customer-Details-List';
import ForgotPassword from './views/Forgot-Password';
import Dashboard from './views/Dashboard';
import { toast, ToastContainer } from 'react-toastify';
import PayPage from './views/Payment-Page';
import { useEffect, useState } from 'react';
import CustomerView from './views/Customer-View';
import Collections from './views/Collections';
import ClosedLoans from './views/Reports/Closed-Loans';
import AdminRegister from './views/Admin-Register';
import ProtectedRoute from './common/ProtecteRoute';
import AddInvestor from './views/Add-Investor-Details';
import superAdminApis from './api/services/admin-pages/superAdmin';
import ProfileSettings from './views/Profile-Settings';

function App() {

 useEffect(() => {

// handleInvestorList();

    const preventScrollOnNumber = (e) => {
      const active = document.activeElement;
      if (active && active.type === "number") {
        e.preventDefault(); // stops number from changing
      }
    };

    document.addEventListener("wheel", preventScrollOnNumber, { passive: false });

    return () => {
      document.removeEventListener("wheel", preventScrollOnNumber);
    };
  }, []);

  const [customerList, setCustomerList] = useState([]);
    const [additionalData, setAdditionalData] = useState([]);
  const [showNotification, setShowNotification] = useState(false);
const [expireName, setExpireName] = useState("");
const [expireDays, setExpireDays] = useState(0);
// const [isLoggedIn, setIsLoggedIn] = useState(false);

const [isLoggedIn, setIsLoggedIn] = useState(
  localStorage.getItem("isLoggedIn") === "true"
);



useEffect(() => {
  if (!isLoggedIn) return; 
  handleInvestorList();
}, [isLoggedIn]);




 const handleInvestorList = (page ) => {

  const apiData = {
   
  };

  superAdminApis.investorList(apiData)
    .then((responseData) => {
      if (responseData?.apiStatus?.code === "200") {
        setAdditionalData(responseData?.result?.investorDetails || []);
      } else {
        setAdditionalData([]);
      }
    })
    .catch(() => {
      toast.error("An error occurred");
    });
};


// useEffect(() => {
//   if (!isLoggedIn || additionalData.length === 0) return;

//   const nearExpiry = additionalData.find((item) => {
//     const start = new Date(item.date);
//     let expiry = new Date(start);

//     if (item.pay_duration === "Weekly") {
//       expiry.setDate(start.getDate() + 7);
//     } else {
//       expiry.setDate(start.getDate() + 30);
//     }

//     const diff = Math.ceil((expiry - new Date()) / (1000 * 60 * 60 * 24));
//     return diff > 0 && diff <= 6;
//   });

//   if (nearExpiry) {
//     setShowNotification(true);
//     setExpireName(nearExpiry.name);
//     setExpireDays(nearExpiry.remaining_days || 2);
//     if (isLoggedIn) setShowNotification(true);
//   }
// }, [isLoggedIn, additionalData]);



// App.js
useEffect(() => {
  if (!isLoggedIn || additionalData.length === 0) return;

  const expiringSoon = additionalData.filter(item => {
    // 🔥 1. Choose correct start date
    let start = item.pay_date ? new Date(item.pay_date) : new Date(item.date);

    // 🔥 2. Calculate expiry based on pay_duration
    let expiry = new Date(start);

    if (item.pay_duration === "Weekly") {
      expiry.setDate(start.getDate() + 7);
    } else {
      expiry.setDate(start.getDate() + 30);
    }

    // 🔥 3. Remaining days
    const diff = Math.ceil((expiry - new Date()) / (1000 * 60 * 60 * 24));

    item.remaining_days = diff;

    // return items that expire soon (2 or 1 days)
    return diff <= 2 && diff > 0;
  });

  if (expiringSoon.length > 0) {
    setExpireName(expiringSoon.map(e => e.name).join(", "));
    setExpireDays(expiringSoon[0].remaining_days);
    setShowNotification(true);
  } else {
    setShowNotification(false);
  }

}, [isLoggedIn, additionalData]);





  return (
    <div className="App">

{showNotification && expireDays > 0 && expireDays <= 2 && (
  <div className="notification-popup">
    <div className="notification-close" onClick={() => setShowNotification(false)}>
      &times;
    </div>

    <h6 className="fw-bold">Expiry Alert!</h6>
    <p>
      <strong>{expireName}</strong> investment will expire in  
      <strong> {expireDays} day(s)</strong>.
    </p>
  </div>
)}



    <BrowserRouter>
  <Routes>

    {/* PUBLIC ROUTES */}
    <Route path="/" element={<AdminLogin setIsLoggedIn={setIsLoggedIn} setShowNotification={setShowNotification} />} />
    <Route path="/sign-up" element={<AdminRegister />} />
    <Route path='/forgot-password' element={<ForgotPassword/>}/>

    {/* <Route path="/customer-details/create" element={<CustomerDetails />} /> 
    <Route path="/customer-details/edit/:id" element={<CustomerDetails />} /> */}

    {/* PROTECTED ROUTES */}
    <Route
      path="/navbar"
      element={
        <ProtectedRoute>
          <Navbars />
        </ProtectedRoute>
      }
    />

    

    <Route
      path="/customer-details/create"
      element={
        <ProtectedRoute>
          <CustomerDetails />
        </ProtectedRoute>
      }
    />

    <Route
      path="/customer-details/edit/:id"
      element={
        <ProtectedRoute>
          <CustomerDetails />
        </ProtectedRoute>
      }
    />

    <Route
      path="/customer-view/:id"
      element={
        <ProtectedRoute>
          <CustomerView />
        </ProtectedRoute>
      }
    />

    <Route
      path="/customer-details-list"
      element={
        <ProtectedRoute>
          <CustomerDetailsList
            customerList={customerList}
            setCustomerList={setCustomerList}
          />
        </ProtectedRoute>
      }
    />

    <Route
      path="/dashboard"
      element={
        <ProtectedRoute>
          <Dashboard 
           customerList={customerList}
            setCustomerList={setCustomerList}
          />
        </ProtectedRoute>
      }
    />

    <Route
      path="/customer-pay/:customerId"
      element={
        <ProtectedRoute>
          <PayPage
            customerList={customerList}
            setCustomerList={setCustomerList}
          />
        </ProtectedRoute>
      }
    />

    <Route
      path="/customer-collections"
      element={
        <ProtectedRoute>
          <Collections />
        </ProtectedRoute>
      }
    />

    <Route
      path="/reports/closed-loans"
      element={
        <ProtectedRoute>
          <ClosedLoans />
        </ProtectedRoute>
      }
    />

    <Route
    path='/add-investor'
    element={
       <ProtectedRoute>
    <AddInvestor/>
       </ProtectedRoute>
  }
    />

    <Route
    path='/profile-settings'
    element={
       <ProtectedRoute>
    <ProfileSettings/>
       </ProtectedRoute>
  }
    />

    {/* 404 PAGE */}
    <Route path="*" element={<Page404 />} />

  </Routes>
</BrowserRouter>



            <ToastContainer
        className="toast-position"
        position="bottom-right"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        style={{ width: "500px" }}
      // #00D26E
      />

    </div>
  );
}

export default App;
